import React from 'react';
import { connect } from 'react-redux';
import { createMaterialTopTabNavigator } from 'react-navigation-tabs';
import { StyleSheet } from 'react-native';

import { NavigationTabs, closeAllModals } from '../ui';
import { WorkoutHistoryScreen } from '../WorkoutHistory';
import TrackingWorkoutStatsTile from '../Tracking/tracking-workout-stats';

const StatsTabNavigation = createMaterialTopTabNavigator({
  History: {
    screen: WorkoutHistoryScreen,
    navigationOptions: {
      tabBarLabel: 'History',
    }
  },
  BodyScans: {
    screen: TrackingWorkoutStatsTile,
    navigationOptions: {
      tabBarLabel: 'Detail',
    }
  },
}, {
    lazy: true,
    swipeEnabled: true,
    backBehavior: 'none',
    tabBarPosition: 'top',
    tabBarComponent: props => (
      <StatsTabWrapped {...props} />
    ),
  });

const mapDispatchToProps = (dispatch) => {
  return {
    onTabPressOverride: () => dispatch(closeAllModals()),
  }
}

const StatsTabWrapped = connect(null, mapDispatchToProps)(NavigationTabs);

const styles = StyleSheet.create({
  iconContainer: {
    marginRight: 10,
  }
});

export default StatsTabNavigation;
